import { render, staticRenderFns } from "./managementPlan.vue?vue&type=template&id=52c16c84&scoped=true"
import script from "./managementPlan.vue?vue&type=script&lang=js"
export * from "./managementPlan.vue?vue&type=script&lang=js"
import style0 from "./managementPlan.vue?vue&type=style&index=0&id=52c16c84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c16c84",
  null
  
)

export default component.exports